import firebase from "./index";

export default firebase.firestore();
